module.exports = __webpack_public_path__ + "img/Woodward_Horizontal_2c_TM.0c53d5ff.png";